import { render } from "./RuleItem.vue?vue&type=template&id=85bc039c"
import script from "./RuleItem.vue?vue&type=script&lang=js"
export * from "./RuleItem.vue?vue&type=script&lang=js"

import "./RuleItem.vue?vue&type=style&index=0&id=85bc039c&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__